export default __webpack_public_path__ + "static/media/card2.faa898c2.png";